import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Hickory Crawdads account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=DHCM_MYTIXX&orgid=57072#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DDHCM_MYTIXX%26orgid%3D57072"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Hickory Crawdads Game Pack program work?",
    description:
      "The Crawdads Game Pack program allows fans to select any seat to select games hosted by the Hickory Crawdads. Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Crawdads{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=DHCM_MYTIXX&orgid=57072#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DDHCM_MYTIXX%26orgid%3D57072"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyProVenue
        </Link>{" "}
        Account.
      </>
    ),
  },
];
